/** Libellés FR partagés pour tous les modèles de CV */
export const CV_LABELS = {
    contact: 'Contact',
    about: 'À propos',
    skills: 'Compétences',
    experience: 'Expériences',
    education: 'Formations',
    interests: "Centres d'intérêt",
    languages: 'Langues',
    references: 'Références',
    profile: 'Profil',
    suite: 'Suite',
    present: 'Présent',
    publicProfile: 'Profil public',
} as const;

export const frPresent = (isCurrent: boolean, endDate: string) =>
    isCurrent ? CV_LABELS.present : endDate;
